export const enum ZupRequestStatusType {
  /* на формировании в 1С */
  processing = 'processing',
  /* успешно сформировано в 1С */
  success = 'success',
  /* ошибка при формировании в 1С */
  error = 'error',
}
